<template>
<div id="login"> 
    <div  class="container">
		<div  class="container-login100" style="background-image: url('src/assets/bg-01.jpg');">
      <div   class="container">
        <div class="card-title" > 
          <img  src='https://firebasestorage.googleapis.com/v0/b/pg-app-fd8a7.appspot.com/o/logo%2FScreenshot%20from%202021-11-18%2021-20-57.png?alt=media&token=fd08a024-e3a8-4904-ad3d-31d4ec3824c7' alt='logo'/>
        </div>
        <br>
        <p class="card-title" > <tt> How you are ? </tt>  </p>
        <div class="row">
          <div class="col-md p-2"   >
            <router-link style="float: " to="/login">
            <div class="card p-5 shadow mx-auto bg-light card-body" style="width: 20em">
              <h3
                style="text-align: center; color:black; font-weight: 400; margin: 0px"
                class="card-title p-3"
              >
                Tenant
              </h3>
              <div class="card-block"></div>
            </div>
             </router-link>
          </div> 
           
           <div class="col-md p-2">
            <router-link style="float: " to="/ownerlogin">
            <div class="card p-5 shadow mx-auto card-body bg-secondary text-white" style="width: 20em">
              <h3
                style="text-align: center; font-weight: 400; margin: 0px"
                class="card-title p-3"
              >
               Owner
              </h3>
              <div class="card-block"></div>
            </div>
             </router-link>

          </div>
        </div>
      </div>
    </div> 
</div>
  </div>
</template>
<script>
//import { fb } from "../firebase";
export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
    };
  },

  methods: {},
};
</script>

<style  src='../assets/css/login.css' scoped>
</style>


<style scoped>

  #login{
      display: block;
      overflow: auto;
      background-color: #dcdcdc;
      min-height: 100vh;
  }


.title {
  color: aliceblue;
  font-size: 3em;
}

.card-title {
  text-align: center;
  align-self: center;
  align-items: center;
}

.spinner-grow {
  position: fixed;
  left: 0px;
  top: 25%;
  width: 100%;
  height: 50%;
  z-index: 9999;
  background: url("//upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Phi_fenomeni.gif/50px-Phi_fenomeni.gif")
    50% 50% no-repeat;
}

.card-body {
  height: auto;
  width: 100%;
}

.login {
  position: relative;
}

.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}





.container-login100::before {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,.9);
}
</style>